import Api from "./api";

export default {
  async modifyUserEmail(config, userId, payload, userToken) {
    const response = await Api(config, userToken).patch(
      `${config.userApi}/user/${userId}/${payload.type}`,
      payload.body
    );
    return response.data;
  },
  async sendEmailConfirmation(config, userId, userToken) {
    const response = await Api(config, userToken).post(`${config.userApiv2}/user/${userId}/resend`);
    return response.data;
  },
  async deleteUser(config, userId) {
    const response = await Api(config).delete(`${config.userApi}/user/${userId}`);
    return response.data;
  },
  async setChild(config, child) {
    const response = await Api(config).post(`${config.userApi}/user/`, child);
    return response.data;
  },
  async getUser(config, force) {
    let url;
    if (force) {
      url = `${config.api.fetchUser}update/`;
    } else {
      url = config.api.fetchUser;
    }
    const response = await Api(config).get(url, { withCredentials: true });
    return response.data;
  },
  async modifyUserEntities(config, userId, userChanges, userToken) {
    const response = await Api(config, userToken).patch(`${config.userApi}/user/${userId}`, userChanges);
    return response.data;
  },
  async modifyUserPassword(config, userId, pwdChanges, userToken) {
    const response = await Api(config, userToken).patch(`${config.userApi}/user/${userId}/password`, pwdChanges);
    return response.data;
  },
  async setFiscalCode(config, fiscalCode) {
    const response = await Api(config).patch(`${config.api.setFiscalCode}`, { fiscal_code: fiscalCode });
    return response.data;
  },
};
